/**
 * Mock Data for Development
 * Used by admin and creator pages for local development
 */

export interface MockLicense {
  key: string;
  user: string;
  customer: string;
  product: string;
  creator: string;
  activations: number;
  maxActivations: number;
  issued: string;
  status: 'active' | 'suspended' | 'expired';
}

export interface MockUser {
  id: string;
  name: string;
  email: string;
  role: 'admin' | 'creator' | 'user';
  status: 'active' | 'inactive' | 'suspended';
  joined: string;
  createdAt: string;
}

/**
 * Mock licenses for admin/creator dashboard
 */
export const mockLicenses: MockLicense[] = [
  {
    key: 'VTOD-XXXX-XXXX-0001',
    user: 'john@example.com',
    customer: 'John Doe',
    product: 'Vintage Tube Overdrive',
    creator: 'SoundForge',
    activations: 2,
    maxActivations: 3,
    issued: '2024-01-15',
    status: 'active',
  },
  {
    key: 'CRVB-XXXX-XXXX-0002',
    user: 'jane@example.com',
    customer: 'Jane Smith',
    product: 'Crystal Reverb',
    creator: 'AudioLabs',
    activations: 1,
    maxActivations: 3,
    issued: '2024-02-20',
    status: 'active',
  },
  {
    key: 'VTOD-XXXX-XXXX-0003',
    user: 'bob@example.com',
    customer: 'Bob Wilson',
    product: 'Vintage Tube Overdrive',
    creator: 'SoundForge',
    activations: 3,
    maxActivations: 3,
    issued: '2024-01-10',
    status: 'suspended',
  },
  {
    key: 'ADLP-XXXX-XXXX-0004',
    user: 'alice@example.com',
    customer: 'Alice Johnson',
    product: 'Analog Delay Pro',
    creator: 'RetroFX',
    activations: 2,
    maxActivations: 3,
    issued: '2023-06-01',
    status: 'expired',
  },
  {
    key: 'MCMP-XXXX-XXXX-0005',
    user: 'charlie@example.com',
    customer: 'Charlie Brown',
    product: 'Modern Compressor',
    creator: 'DynamicAudio',
    activations: 0,
    maxActivations: 3,
    issued: '2024-03-05',
    status: 'active',
  },
];

/**
 * Mock users for admin user management
 */
export const mockUsers: MockUser[] = [
  {
    id: 'user-001',
    name: 'John Doe',
    email: 'john@example.com',
    role: 'user',
    status: 'active',
    joined: '2024-01-01',
    createdAt: '2024-01-01T00:00:00Z',
  },
  {
    id: 'user-002',
    name: 'Jane Smith',
    email: 'jane@example.com',
    role: 'creator',
    status: 'active',
    joined: '2024-01-15',
    createdAt: '2024-01-15T00:00:00Z',
  },
  {
    id: 'user-003',
    name: 'Bob Wilson',
    email: 'bob@example.com',
    role: 'user',
    status: 'suspended',
    joined: '2024-02-01',
    createdAt: '2024-02-01T00:00:00Z',
  },
  {
    id: 'user-004',
    name: 'Alice Johnson',
    email: 'alice@example.com',
    role: 'admin',
    status: 'active',
    joined: '2023-12-01',
    createdAt: '2023-12-01T00:00:00Z',
  },
  {
    id: 'user-005',
    name: 'Charlie Brown',
    email: 'charlie@example.com',
    role: 'user',
    status: 'inactive',
    joined: '2024-02-15',
    createdAt: '2024-02-15T00:00:00Z',
  },
];
